
export default function Map() {

    const map = <iframe title="Precinct Map" style={{ width: "100%", maxHeight: "100%", overflow: "hidden", overflowX: "hidden", overflowY: "hidden" }} height="600" width="1200" src="https://experience.arcgis.com/experience/caa2de39e2414120a8c81bfa728c4ea1/" />

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div className="container py-4">
                    <div className="row">
                        <div className='col-lg-12 col-md-12'>
                            <div className="card shadow mb-3">
                                <div className='card-body'>
                                    {map}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    )
}